<template>
  <div>
    <div class="mt-14">
      <h3 class="my-8 text-3xl">
        STEP１：Amazon Seller Central
      </h3>
      <div v-show="!this.activeAccount.spApiOauthComplete">
        <paragraph
          class="my-8 flex rounded p-3"
          style="background-color: #EDEDED;"
        >
          <VueFeather
            type="info"
            class="feather-icon feather-icon-css-target"
          />
          <p>複数のセラーアカウントお持ちの場合は、事前に接続をおこないたいアカウントにログインした状態で以下リンクをクリックしてください。</p>
        </paragraph>
      </div>
      <div class="text-center pt-4">
        <img
          v-if="!activeAccount.spApiOauthComplete && !spApiButtonClicked"
          class="cursor-pointer"
          alt="Login with Amazon for SPApi"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png"
          width="312"
          height="64"
          @click="onSpApiButtonClicked"
        />
        <img
          v-else-if="spApiButtonClicked"
          class="cursor-pointer"
          alt="Login with Amazon for SPApi"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64_pressed.png"
          width="312"
          height="64"
          @click="onSpApiButtonClicked"
        />
        <img
          v-else
          class="button-disabled cursor-not-allowed"
          alt="Login with Amazon for SPApi"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png"
          width="312"
          height="64"
        />
      </div>
    </div>
    <div class="mt-14">
      <h3 class="my-8 text-3xl">
        STEP２：Amazon Advertising
      </h3>
      <template v-if="adAccountConnected">
        <paragraph class="my-8">スポンサー広告アカウントを誤って接続した場合は、<a href="https://www.ubun.co.jp/ad_off" target="_blank">こちら</a>からアカウント解除の申請をお願いします。</paragraph>
      </template>
      <template v-if="beforeAdAccountConnected || adApiButtonClicked">
        <paragraph class="my-8">
          広告コンバージョン（CV）の定義を選択してください。
        </paragraph>
        <ad-cv-form
          v-model:ad-sd-cv-type="adSdCvType"
          v-model:ad-sp-cv-type="adSpCvType"
          v-model:ad-sb-cv-type="adSbCvType"
          class="my-12"
        />
      </template>
      <div class="text-center pt-4">
        <img
          v-if="beforeAdAccountConnected"
          class="cursor-pointer"
          alt="Login with Amazon for AdAPI"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png"
          width="312"
          height="64"
          @click="onAdApiButtonClicked"
        />
        <img
          v-else-if="adApiButtonClicked"
          class="cursor-pointer"
          alt="Login with Amazon for AdAPI"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64_pressed.png"
          width="312"
          height="64"
          @click="onAdApiButtonClicked"
        />
        <img
          v-else
          class="button-disabled cursor-not-allowed"
          alt="Login with Amazon for AdAPI"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png"
          width="312"
          height="64"
        />
      </div>
    </div>
    <div class="mt-14">
      <h3 class="my-8 text-3xl">
        OPTION：Amazon Marketing Cloud（AMC）
      </h3>
      <template v-if="amcAccountConnected">
        <paragraph class="my-8">初期状態では、Ubun BASEが新規に開設したAMCインスタンスに接続します。
          別のAMCアカウントに接続を切り替えたい場合は、<a href="https://www.ubun.co.jp/amc_off" target="_blank">こちら</a>からアカウント解除の申請をお願いします。
        </paragraph>
      </template>
      <template v-if="beforeAmcAccountConnected || amcApiButtonClicked">
        <ValidationForm ref="amcInputObserver">
          <paragraph class="my-8">AMCアカウントをUbun BASEに接続することで、Ubun BASE上でAMCのレポートを確認することができます。接続するには該当のAMCインスタンスへのアクセス権限を持つユーザーによって作業が必要です。

接続前に、AMCの管理画面のInstance infoで「Connected AWS account ID」に528059411261を登録してください。
登録方法やIDの確認方法については、<a :href="amcHelpUrl" target="_blank" rel="nofollow">こちら</a>をご確認ください。
</paragraph>
          <HorizontalFieldLayout
            class="mt-8"
            label="Entity ID"
            label-field-ratio="2/7"
          >
            <EntityIdField
              v-model="amcAccountId"
              name="Entity ID"
            />
          </HorizontalFieldLayout>
          <HorizontalFieldLayout
            class="mt-8"
            label="Instance ID"
            label-field-ratio="2/7"
          >
            <InputField
              v-model="amcInstanceId"
              name="Instance ID"
              rules="required"
            />
          </HorizontalFieldLayout>
        </ValidationForm>
      </template>
      <div class="text-center pt-4">
        <img
          v-if="beforeAmcAccountConnected"
          class="cursor-pointer"
          alt="Login with Amazon for AMC API"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png"
          width="312"
          height="64"
          @click="onAmcApiButtonClicked"
        />
        <img
          v-else-if="amcApiButtonClicked"
          class="cursor-pointer"
          alt="Login with Amazon for AMC API"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64_pressed.png"
          width="312"
          height="64"
          @click="onAmcApiButtonClicked"
        />
        <img
          v-else
          class="button-disabled cursor-not-allowed"
          alt="Login with Amazon for AMC API"
          src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png"
          width="312"
          height="64"
        />
      </div>
    </div>
    <vs-popup
      v-model:active="showPopup"
      :title="popupTitle"
    >
      <div
        class="text-center leading-loose"
        v-html="popupMessage"
      />
    </vs-popup>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import axios from '@/user/axios'
import store from '@/user/store/store'
import EntityIdField from '@/components/fields/EntityIdField'
import InputField from '@/components/fields/InputField'
import AdCvForm from '@/components/forms/AdCvForm'
import Paragraph from '@/components/Paragraph'
import HorizontalFieldLayout from '@/components/layouts/form/HorizontalFieldLayout'

export default {
  name: 'Oauth',
  components: {
    HorizontalFieldLayout,
    Paragraph,
    AdCvForm,
    EntityIdField,
    InputField
  },
  beforeRouteEnter (to, from, next) {
    next(async () => {
      try {
        const activeAccount = store.state.account.activeAccount
        if (!activeAccount.spApiOauthComplete || !activeAccount.adApiOauthComplete || !activeAccount.amcApiOauthComplete) {
          await store.dispatch('account/getAccount')
        }
      } catch (e) {
        console.error(e)
      }
    })
  },
  data () {
    return {
      spApiButtonClicked: false,
      adApiButtonClicked: false,
      amcApiButtonClicked: false,
      showPopup: false,
      popupTitle: '',
      popupMessage: '',
      adSdCvType: 3,
      adSpCvType: 1,
      adSbCvType: 1,
      amcAccountId: null,
      amcInstanceId: null,
      amcHelpUrl: `${process.env.VUE_APP_BASE_API_URL}/api/resource?u=https%3A%2F%2Fresource.ubun.jp%2F2024%2F05%2F20%2Famc%2F`
    }
  },
  computed: {
    ...mapState('account', ['activeAccount']),
    ...mapState('auth', ['token']),
    adAccountConnected () {
      return this.activeAccount.adApiOauthComplete
    },
    amcAccountConnected () {
      return this.activeAccount.amcApiOauthComplete
    },
    beforeAdAccountConnected () {
      return this.activeAccount.spApiOauthComplete && !this.activeAccount.adApiOauthComplete && !this.adApiButtonClicked
    },
    beforeAmcAccountConnected () {
      return this.activeAccount.spApiOauthComplete && !this.activeAccount.amcApiOauthComplete && !this.amcApiButtonClicked
    }
  },
  mounted () {
    if (Object.keys(this.$route.query).length > 0) {
      const { message, success } = this.$route.query
      if (success === 'false') {
        let title = 'アカウント連携エラー'
        let m = 'エラーが発生しました。<br>カスタマーサポートまでお問い合わせください。<br>tech@ubun.co.jp'
        switch (message) {
          case 'the sellerId is already registered':
            title = 'このアカウントは接続することができません。'
            m = '本amazon出品者アカウントは、既にubun baseに連携済みです。<br>カスタマーサポートまでお問い合わせください。<br>tech@ubun.co.jp'
            break
          default:
            break
        }
        this.popupTitle = title
        this.popupMessage = m
        this.showPopup = true
      }
    }
  },
  methods: {
    ...mapActions('account', ['updateAccount']),
    onSpApiButtonClicked () {
      this.spApiButtonClicked = !this.spApiButtonClicked
      if (this.spApiButtonClicked) {
        window.location.href = `${axios.defaults.baseURL}/api/oauth/sp/redirect?accountId=${this.activeAccount.id}&token=${this.token}`
      }
    },
    async onAdApiButtonClicked () {
      this.adApiButtonClicked = !this.adApiButtonClicked
      if (this.adApiButtonClicked) {
        try {
          await this.updateAccount({
            ...this.activeAccount,
            adSdCvType: this.adSdCvType,
            adSpCvType: this.adSpCvType,
            adSbCvType: this.adSbCvType
          })
          window.location.href = `${axios.defaults.baseURL}/api/oauth/ad/redirect?accountId=${this.activeAccount.id}&token=${this.token}`
        } catch (e) {
          console.log(e)
        }
      }
    },
    async onAmcApiButtonClicked () {
      this.amcApiButtonClicked = !this.amcApiButtonClicked
      if (this.amcApiButtonClicked) {
        const isValid = await this.$refs.amcInputObserver.validate()
        if (!isValid.valid) {
          this.amcApiButtonClicked = false
          return
        }
        window.location.href = `${axios.defaults.baseURL}/api/oauth/amc/redirect?accountId=${this.activeAccount.id}&amcAccountId=${this.amcAccountId}&amcInstanceId=${this.amcInstanceId}&token=${this.token}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button-disabled {
  filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale"); /* Firefox 3.5+ */
  -webkit-filter: grayscale(100%); /* Chrome 19+ & Safari 6+ */
}
.mt-14 {
  margin-top: 5rem !important;
}
.mt-18 {
  margin-top: 9rem !important;
}
h2 {
  font-weight: 700 !important;
}
h3 {
  font-weight: 600 !important;
}
</style>

<style scoped>
.feather-icon-css-target :deep(.vue-feather__content) {
  width: 1.5rem !important;
  height: 1.5rem !important;
  margin-right: 0.5rem !important;
}
</style>
